/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CompetenceListItemViewModelPaginatedResponse } from "../types/CompetenceListItemViewModelPaginatedResponse.ts";
import { competenceListItemViewModelSchema } from "./competenceListItemViewModelSchema.ts";

export const competenceListItemViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => competenceListItemViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<CompetenceListItemViewModelPaginatedResponse>;
